import Link from "next/link";
import { PrismicNextLink } from "@prismicio/next";
import { LinkField } from "@prismicio/client";
import { ReactNode } from "react";

type LinkHelperProps = {
  link: string | LinkField | null | undefined;
  children: ReactNode;
  className?: string;
};

export const LinkHelper = ({ link, children, className }: LinkHelperProps) => {
  // Handle null/undefined cases
  if (!link) {
    return <div className={className}>{children}</div>;
  }

  // Handle string URLs
  if (typeof link === "string") {
    return (
      <Link scroll={false} href={link} className={className}>
        {children}
      </Link>
    );
  }

  // Handle Prismic LinkField
  return (
    <PrismicNextLink field={link} className={className}>
      {children}
    </PrismicNextLink>
  );
};
